/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_DescriptionInputs */



/**
* | output |
* | --- |
* | "Reference prices for all AI models available on oneAI." |
*
* @param {Model_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_description = /** @type {((inputs?: Model_Pricing_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Referenzpreise für alle auf oneAI verfügbaren KI-Modelle.")
	return /** @type {LocalizedString} */ ("Reference prices for all AI models available on oneAI.")
});